export enum PromotionEnum {
  BonusInForm = 'bonus w postaci',
  FillInDataToBookBonus = 'Uzupełnij dane i zarezerwuj bonus na 3 miesiące.',
  Voucher = 'voucher',
  Voucher1 = 'vouchera',
}

export enum PromotionTypeDescriptionEnum {
  Bonus = 'Bonus',
  Bonus1 = 'BONUS',
  EmployeeBonus = 'Bonus pracowniczy',
  Voucher = 'Voucher',
  Fundraising = 'Zbiorka funduszy',
}
